import { Signal, createEffect, createMemo, createSignal, onMount } from "solid-js";
import { SolidFramework, SolidFrameworkContext } from "common";
import { ViewContextJSX } from 'st-app';
import { ViewContext } from "../st-view/ViewContext";
import ViewControl from '../st-view-control/st-view-control'

export class STComponentWrapperProps {
    componentName = ''
    viewId?= ''
    identity?= ''
    srcObject? = ''
    srcElement? = ''
    affectsStatus? = ''
    primaryObjectGU? = ''
    value ?= ''
    events? = {
        onValueSet: (value: any) => { },
        refresh: () => { },
        setValue: (value: any) => { },
        setOldValue: (value: any) => { },
        setProps: (value: any) => { },
    }
}

export default function STComponentWrapper(props: STComponentWrapperProps) {
    const [value, setValue] = createSignal<any | undefined>(undefined)
    const [oldValue, setOldValue] = createSignal<any | undefined>(undefined)
    const [userProps, setUserProps] = createSignal<any>({})
    const affectsStatus = createMemo(() => props.affectsStatus === 'true')

    onMount(() => {
        createEffect((prev) => {
            if (prev !== value() && props.events?.onValueSet) {
                props.events?.onValueSet(value())
            }
        }, value())
    });

    const { component: Component, defaultProps } = window.solidComponents[props.componentName]

    if (props.events) {
        props.events.setValue = setValue
        props.events.setProps = setUserProps
        props.events.setOldValue = setOldValue
    }

    const componentProps = createMemo(() => ({
        ...defaultProps,
        ...(userProps() ?? {})
    }));

    const ctx = new ViewContext();
    ctx.events = props.events ?? {};


    function InnerWrapper() {
        createEffect(() => ctx.setViewId(props.viewId ?? ''));
        createEffect(() => ctx.setIdentity(props.identity ?? ''));
        createEffect(() => ctx.setPrimaryObjectGU(props.primaryObjectGU ?? ''));

        return (
            <ViewControl
                value={[value, setValue]}
                oldValue={[oldValue, setOldValue]}
                srcElement={props.srcElement}
                srcObject={props.srcObject}
                affectsStatus={affectsStatus()}
            >
                <Component srcElement={props.srcElement} srcObject={props.srcObject} {...componentProps()} value={value()} setValue={setValue} />
            </ViewControl>
        )
    }

    return <ViewContextJSX.Provider value={ctx}>
        <SolidFrameworkContext.Provider value={new SolidFramework()}>
            <InnerWrapper></InnerWrapper>
        </SolidFrameworkContext.Provider>
    </ViewContextJSX.Provider>
}

STComponentWrapper.defaultProps = new STComponentWrapperProps();


